import TableHeader from './table_header';
import TableRow from './table_row';
import TableCellRenderFactory from 'grid/table_cell_render_factory';
import { GridFormStore } from 'grid_form/reflux/grid_form_store';

const RealizeTable = window.Table;

export default class Table extends RealizeTable {
	static defaultProps = {
		...RealizeTable.defaultProps,
		tableRowComponent: TableRow,
	};

	constructor(props) {
		super(props);
		this.renderTableRows = Table.prototype.renderTableRows.bind(this);
		if(this.props.typeScreen !== 'duplicate-document'){
			this.renderTableHeaders = Table.prototype.renderTableHeaders.bind(this);
		}
	}

	filterActionButtons(dataRow) {
		const storeItem = GridFormStore.store[this.props.gridId];
		let actionButtonsFiltered = this.props.actionButtons.member || [];

		if (!storeItem)
			return actionButtonsFiltered;

		const { propsRows } = storeItem;

		if (Array.isArray(actionButtonsFiltered) && propsRows && propsRows[dataRow.id] && propsRows[dataRow.id].visibleEdit === false)
			actionButtonsFiltered = actionButtonsFiltered.filter(a => a.id !== `${this.props.gridId}_edit`);

		if (Array.isArray(actionButtonsFiltered) && propsRows && propsRows[dataRow.id] && propsRows[dataRow.id].visibleDelete === false)
			actionButtonsFiltered = actionButtonsFiltered.filter(a => a.id !== "destroy");

		return actionButtonsFiltered;
	}

	renderTableRow(dataRow, index) {
		const { tableRowComponent: TableRowComponent } = this.props;
		const storeItem = GridFormStore.store[this.props.gridId];

		if (storeItem) {
			const { propsRows } = storeItem;

			if (propsRows && propsRows[dataRow.id] && propsRows[dataRow.id].visibleRow === false)
				return null;
		}

		return (
			<TableRowComponent
				{...this.propsWithoutCSS()}
				onSelectToggle={this.toggleDataRows}
				selected={this.dataRowIsSelected(dataRow)}
				data={dataRow}
				dataRowIdField={this.props.dataRowIdField}
				actionButtons={this.filterActionButtons(dataRow)}
				key={`table_row_${index}`}
				rowSelectableFilter={this.props.rowSelectableFilter}
				onClickRow={this.props.onClickRow}
				rowHref={this.props.rowHref}
				tableRowCssClass={this.props.tableRowCssClass}
			/>
		);
	}

	renderTableRows() {
		const { dataRows } = this.props;
		return dataRows.map(this.renderTableRow.bind(this));
	}

	renderTableHeader([columnName, columnProps]) {
		return (
			<TableHeader
				{...columnProps}
				{...this.sortConfigs}
				label={columnProps.label || ''}
				name={columnName}
				key={columnName}
				sortDirection={this.sortDirectionForColumn(columnName, columnProps)}
				ref={"header_" + columnName}
				resource={this.props.resource}
				onSort={this.props.onSort}
				clearTheme={this.props.clearTheme}
				onSortTable={this.props.onSortTable}
				filterClientSideTable={this.props.filterClientSideTable}
				isMobile={this.props.isMobile}
				fields={this.props.fields}
			/>
		);
	}

	renderTableHeaders() {
		const { columns } = this.props;

		if (this.props.contextType === 'GRID' && !this.props.readOnly && !this.props.disabled) {
			columns['ACTIONS'] = {
				component: TableCellRenderFactory,
				format: "text",
				label: Realize.i18n.t('table.columnActions'),
				name: "ACTIONS",
				visible: true,
				className: 'column-fixed-actions'
			};
		}

		return Object.entries(columns)
			.filter(([columnName, columnProps]) => !!columnProps.visible)
			.map(this.renderTableHeader.bind(this));
	}
}
